import React from 'react';
import { useModel } from "bcms-react";
import "./styles.css";

import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
/**
 * @function ExternalTransfersPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ExternalTransfersPage
 */
export default function ExternalTransfersPage(props) {
  const { branding } = useModel();
  const demo = branding.options.tn_version_abi22 === "Legacy" ? "TNLegacy" : "TN19";

  return (
    <PageContainer className="external-transfers-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="External Transfers"/>
          {/* iFrame for TN19 goes here */}
          <ExternalIframe demo={ demo } className="external-transfers-iframe"  key ="ExternalTransfersPage"/>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
